// this code is responsive for mobile view and desktop view and also generate pdf with multiple vouchers
// old code is not responsive for mobile view and that code paste in oldVoucher.jsx file


import React, {
  useState, useRef, useContext, useEffect,
} from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import PropTypes from 'prop-types';
import { Button } from '@/shared/components/Button';
import { QRCodeSVG } from 'qrcode.react';
import { GlobalContext } from '../../../context/GlobalContext';

const VoucherPDF = ({ bookingID }) => {
  const [voucherData, setVoucherData] = useState([]);
  const [paxDetails, setPaxDetails] = useState([]);
  const [logo, setLogo] = useState(null); // State to store logo
  const [adImage, setAdImage] = useState(null);
  const { apiGlobal } = useContext(GlobalContext);
  const contentRefs = useRef([]);
  
  // Add window size tracking hook
  const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
      width: typeof window !== 'undefined' ? window.innerWidth : 768,
      height: typeof window !== 'undefined' ? window.innerHeight : 1024,
    });

    useEffect(() => {
      if (typeof window === 'undefined') return () => {};
      
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
  };

  const { width } = useWindowSize();
  const isMobile = width < 768;

  const fetchVoucherData = async () => {
    const formData = new FormData();
      formData.append('booking_id', bookingID);
    try {
      const url = await fetch(`${apiGlobal}/agent/voucher_data.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      if (response.status && response.message === 'Success' && response.data) {
        setVoucherData(response.data);
        setPaxDetails(response.data[0].pax_details.flat());
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchVoucherData();
  }, [bookingID, apiGlobal]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogo(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAdImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Pre-load the image to check dimensions
        const img = new Image();
        img.onload = () => {
          setAdImage(reader.result);
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const getMealType = (mealOffered) => {
    switch (mealOffered) {
      case '1':
        return 'breakfast';
      case '2':
        return 'snacks';
      case '3':
        return 'lunch';
      case '4':
        return 'dinner';
      default:
        return null; // Return null if no match
    }
  };

  // Optimize elements for PDF rendering
  const optimizeForPdf = () => {
    const voucherElements = contentRefs.current.map(ref => ref.current);
    
    // Temporarily adjust styles for PDF rendering
    voucherElements.forEach((element) => {
      if (element) {
        // Force fixed width for PDF
        // eslint-disable-next-line
        element.style.width = '210mm';
        // eslint-disable-next-line
        element.style.maxWidth = '210mm';
        
        // Ensure flex direction is row for PDF
        const contentDiv = element.querySelector('div');
        if (contentDiv) {
          contentDiv.style.flexDirection = 'row';
        }
      }
    });
    
    return () => {
      // Restore original styles after PDF generation
      voucherElements.forEach((element) => {
        if (element) {
          // eslint-disable-next-line
          element.style.width = '100%';
          
          const contentDiv = element.querySelector('div');
          if (contentDiv && isMobile) {
            contentDiv.style.flexDirection = 'column';
          }
        }
      });
    };
  };

  // Improved PDF generation function
  // const handleGeneratePdf = () => {
  //   const restoreStyles = optimizeForPdf();
    
  //   // Use portrait mode for better mobile viewing
  //   // eslint-disable-next-line new-cap
  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const margin = 10; // margin in mm
  //   const contentWidth = pageWidth - (margin * 2);
    
  //   let yOffset = margin; // Starting position with margin
    
  //   const processVouchers = async () => {
  //     try {
  //       // eslint-disable-next-line
  //       for (let i = 0; i < paxDetails.length; i++) {
  //         const input = contentRefs.current[i];
          
  //         if (input && input.current) {
  //           // Check if new page is needed
  //           if (i > 0 && yOffset > pdf.internal.pageSize.getHeight() - 40) {
  //             pdf.addPage();
  //             yOffset = margin;
  //           }
            
  //           try {
  //             // eslint-disable-next-line
  //             const canvas = await html2canvas(input.current, { 
  //               scale: 2,
  //               useCORS: true,
  //               logging: false,
  //               allowTaint: true,
  //             });
              
  //             const imgData = canvas.toDataURL('image/jpeg', 0.95);
  //             const imgWidth = contentWidth;
  //             const imgHeight = (canvas.height * imgWidth) / canvas.width;
              
  //             // Add image to PDF
  //             pdf.addImage(imgData, 'JPEG', margin, yOffset, imgWidth, imgHeight);
              
  //             // Update yOffset for next voucher
  //             yOffset += imgHeight + 10; // 10mm gap between vouchers
  //           } catch (error) {
  //             console.error(`Error capturing voucher ${i}:`, error);
  //           }
  //         }
  //       }
        
  //       pdf.save('all_vouchers.pdf');
  //     } finally {
  //       restoreStyles();
  //     }
  //   };
    
  //   processVouchers();
  // };

  const handleGeneratePdf = () => {
    // eslint-disable-next-line
    const pdf = new jsPDF('l', 'mm', 'a4');
    const imgWidth = 380; // Image width for the PDF
    let yOffset = 1; // Starting Y position
    let count = 0; // Counter to track the vouchers per page

    const addVoucherToPdf = (index, canvas) => {
      // Compress and reduce image quality before adding it to the PDF
      const imgData = canvas.toDataURL('image/jpeg', 1); // Reduce quality (50% quality)

      // Reduce the image size if needed (scale it to fit)
      const scaleHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'JPEG', 0, yOffset, imgWidth, scaleHeight); // Add image in JPEG format
      yOffset += scaleHeight;

      count += 1;

      if (count % 2 === 0) {
        pdf.addPage(); // Create a new page after every 2 vouchers
        yOffset = 10; // Reset for new page
      }
    };

    const processVouchers = () => {
      const voucherPromises = paxDetails.map((data, index) => {
        const input = contentRefs.current[index];

        return new Promise((resolve, reject) => {
          if (input && input.current) {
            // Capture the content as a canvas
            html2canvas(input.current, { scale: 1.5, useCORS: true }) // Reduce scale for lower resolution
              .then((canvas) => {
                addVoucherToPdf(index, canvas);
                resolve();
              })
              .catch((error) => {
                console.error(`Error capturing voucher for index ${index}:`, error);
                reject(error);
              });
          } else {
            reject(new Error(`Content not available for index ${index}`));
          }
        });
      });

      // Wait for all vouchers to be processed before saving the PDF
      Promise.all(voucherPromises)
        .then(() => {
          pdf.save('all_vouchers.pdf'); // Download the PDF after all vouchers are added
        })
        .catch((error) => {
          console.error('Error generating PDF:', error);
        });
    };

    processVouchers(); // Start processing the vouchers
  };
  
  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  return (
    <div>
      {/* Input Controls */}
      <div style={{ marginBottom: '20px', display: 'flex', gap: '20px' }}>
        <div>
          <label htmlFor="logo-upload" style={{ display: 'block', marginBottom: '5px' }}>Upload Logo:</label>
          <input
            id="logo-upload"
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
          />
        </div>
        <div>
          <label htmlFor="ad-upload" style={{ display: 'block', marginBottom: '5px' }}>Upload Advertisement:</label>
          <input
            id="ad-upload"
            type="file"
            accept="image/*"
            onChange={handleAdImageChange}
          />
          <div style={{ fontSize: '12px', color: '#666', marginTop: '3px' }}>
            Recommended ad dimensions: 300x600px (vertical)
          </div>
        </div>
      </div>

      {paxDetails.map((pax, index) => {
        contentRefs.current[index] = contentRefs.current[index] || React.createRef();

        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} ref={contentRefs.current[index]}>
            <div
              style={{
              width: '9in', // Fixed width to accommodate ad
              display: 'flex',
              alignItems: 'stretch', // Makes all children the same height
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              border: '2px dotted black',
            }}
            > 
              <div />
              <div
                style={{
                width: '100%',
                maxWidth: '210mm', // A4 width
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row', // Stack on mobile
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px dotted yellow',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                paddingBottom: '16px',
                backgroundImage: 'url(https://i.ibb.co/cS4jWYts/BG-Blue.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                minHeight: '50mm',
                padding: '20px',
              }}
              >
                {/* Logo Section */}
                {logo && (
                  <div style={{ 
                  width: '120px', 
                  height: '80px', 
                  margin: isMobile ? '0 0 15px 0' : '0 20px 0 0',
                }}
                  >
                    <img 
                      src={logo} 
                      alt="Logo" 
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  </div>
               )}

                <div style={{ flex: 1 }}>
                  <h2 style={{
                  fontSize: '24px', fontWeight: 700, color: 'yellow', marginTop: '10px', marginBottom: '10px',
                }}
                  >
                    {(voucherData[0]?.trip_uid || '') + (bookingID || '') + (pax?.id || '')}
                  </h2>
                  <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 4px' }}>
                    <tbody>
                      <tr>
                        <td style={{ width: '25%', verticalAlign: 'top', color: 'white' }}>Voucher For </td>
                        <td style={{ width: '5%', verticalAlign: 'top', color: 'white' }}>:</td>
                        <td style={{
                        width: '70%', verticalAlign: 'top', textAlign: 'left', color: 'yellow', 
                      }}
                        >
                          {pax.pax_name}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '25%', verticalAlign: 'top', color: 'white' }}>Meal</td>
                        <td style={{ width: '5%', verticalAlign: 'top', color: 'white' }}>:</td>
                        <td style={{
                        width: '70%', verticalAlign: 'top', textAlign: 'left', color: 'yellow', 
                      }}
                        >
                          {voucherData[0]?.meal_name}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '25%', verticalAlign: 'top', color: 'white' }}>Restaurant</td>
                        <td style={{ width: '5%', verticalAlign: 'top', color: 'white' }}>:</td>
                        <td style={{
                        width: '70%', verticalAlign: 'top', textAlign: 'left', color: 'yellow', wordBreak: 'break-word',
                      }}
                        >
                          {voucherData[0]?.restaurant_details?.name}, {voucherData[0]?.restaurant_details?.address1},
                          {voucherData[0]?.restaurant_details?.address2}, {voucherData[0]?.restaurant_details?.area},
                          {voucherData[0]?.restaurant_details?.city}, {voucherData[0]?.restaurant_details?.country} -
                          {voucherData[0]?.restaurant_details?.pincode}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '25%', verticalAlign: 'top', color: 'white' }}>Date & Time</td>
                        <td style={{ width: '5%', verticalAlign: 'top', color: 'white' }}>:</td>
                        <td style={{
                        width: '70%', verticalAlign: 'top', textAlign: 'left', color: 'yellow', 
                      }}
                        >
                          {formatDate(voucherData[0]?.booking_date)}{' '} {getMealType(voucherData[0]?.meal_offered)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* QR Code Section */}
                <div 
                  className="qrholder" 
                  style={{ 
                  minWidth: '100px',
                  marginTop: isMobile ? '15px' : '0', 
                  display: 'flex',
                  justifyContent: 'flex-end', 
                  alignItems: 'center', 
                }}
                >
                  <QRCodeSVG
                    value={`Voucher ID: ${(voucherData[0]?.trip_uid || '') + (bookingID || '') + (pax?.id || '')} 
                    Passenger Name: ${pax.pax_name}`}
                    title="Bitevize Booking"
                    size={100}
                    style={{ width: '100px', height: '100px' }}
                    level="L"
                    boostLevel={false}
                  />
                </div>
                
              </div>
              {/* Right Side Advertisement - Fixed Width */}
              <div style={{ 
                width: '2in', // Fixed width
                flexShrink: 0, // Prevents shrinking
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'forestgreen',
                padding: '5px',
                borderLeft: '1px dotted #ccc',
                overflow: 'hidden', // Prevents content from spilling out
              }}
              >
                {/* Top Ad Section - Takes 75% of height */}
                <div style={{ 
                  height: '75%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '10px',
                  overflow: 'hidden', // Important: Prevents image overflow
                }}
                >
                  {adImage ? (
                    <div style={{ 
                      width: '100%',
                      height: '200px', // Fixed height container
                      overflow: 'hidden', // Important: Prevents image overflow
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    >
                      <img 
                        src={adImage} 
                        alt="Advertisement" 
                        style={{
                          width: '300px',
                          height: '600px',
                          objectFit: 'contain',
                          display: 'block', // optional: removes extra bottom spacing
                          // margin: '0 auto', // optional: center horizontally
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ 
                      padding: '10px', 
                      textAlign: 'center',
                      color: 'white',
                    }}
                    >
                      Upload an ad image
                    </div>
                  )}
                </div>
                
                {/* Bottom Company Info Section - Takes 25% of height */}
                <div style={{ 
                  height: '25%',
                  width: '100%',
                  borderTop: '1px dotted #ccc',
                  padding: '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  fontSize: '12px',
                  color: 'white',
                }}
                >
                  <div>For advertisement inquiries:</div>
                  <div>marketing@yourcompany.com</div>
                  <div>+1 123-456-7890</div>
                </div>
              </div>
              
            </div>
            
            {/* <div
              style={{
                      backgroundColor: 'red',
                      padding: '10px',
                       width: '78%',
                       maxHeight: '100px',
                      overflowY: 'auto',
                    }}
            >
              <p>hello</p>
            </div> */}
            
          </div>
        );
      })}

      {/* Generate PDF Button */}
      <Button 
        variant="outline-primary" 
        title="Download PDF"
        onClick={handleGeneratePdf}
        style={{ marginTop: '20px' }}
      >
        Generate PDF
      </Button>
    </div>
  );
};

VoucherPDF.propTypes = {
  bookingID: PropTypes.string.isRequired,
};

export default VoucherPDF;
